module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7r2n5n-8b505885e83dd83a7e6ab56b3446d32b.svg";